import {requestDopamineAssistantPanel} from 'features/DopamineAssistant/dopamineAssistantPanelEvents'
import {AnalyticsRoutesEnum} from 'interfaces'

import {FeatureHighlightAcceptContext} from './types'

export const openAnalyticsOverviewWithDopamineAssistant = ({
  history,
}: FeatureHighlightAcceptContext): void => {
  history.push(AnalyticsRoutesEnum.ANALYTICS_OVERVIEW)
  requestDopamineAssistantPanel({focusComposer: true})
}
